import { AxiosResponse } from "axios";
import BaseDAO from "../BaseDAO";

class ProxyBaseDAO extends BaseDAO {
  protected basePath: string = `${super.getAPIPath()}/api`;

  protected getBasePath(): string {
    return this.basePath;
  }

  private config: any = {
    headers: {
      "Content-Type": "application/json",
    },
    crossDomain: true,
  };

  public get(key:string, url: string): Promise<AxiosResponse<any>> {
    return super.get(key, url, this.config);
  }

  public post(url: string, body: any): Promise<AxiosResponse<any>> {
    return super.post(url, body, this.config);
  }

  public postWithConfig(url: string, body: any, config: any): Promise<AxiosResponse<any>> {
    return super.post(url, body, config);
  }

  public patch(url: string, body: any): Promise<AxiosResponse<any>> {
    return super.patch(url, body, this.config);
  }

  public delete(url: string, body: any): Promise<AxiosResponse<any>> {
    return super.delete(url, body, this.config);
  }

}

export default ProxyBaseDAO;